import * as React from "react"
import * as Immutable from 'immutable'

import { RentalAdvert, SprocketAsset, User, ContactPerson, VerifiedAspect } from "../../../types/types";
import { replaceWithJsx } from "../../../utils/replace";
import { FormattedNumber } from "react-intl";

import OnClickOut from 'react-onclickoutside'
import { Action, async, AsyncState, fromJSX, Widget, any } from "widgets-for-react";
import { LoaderCircle } from '../../../accommodations/models/loading'

type Props = {
  user: User
  user_placeholder: SprocketAsset
  full_name: string
  tooltip_open: boolean
  contact_person?: ContactPerson
  onTooltipToggle: () => void
  onCloseTooltip: () => void
  overviewPath: string
  verifiedAspects: AsyncState<VerifiedAspect[]>
  setVerifiedAspects: (output: Action<AsyncState<VerifiedAspect[]>>) => void
}

const displayAspects = (): VerifiedAspect[] => ['contact', 'bank_account']

const VerifiedAspects = (props: { aspects: VerifiedAspect[] }) =>
  props.aspects.length > 0 ? (
    <ul className="tooltip__list list--checkmark">
      {displayAspects().map(x =>
        props.aspects.indexOf(x) > -1 ? (
          <li>{I18n.t(`users.verified_aspects.${x}`)}</li>
        ) : (
          <></>
        )
      )}
    </ul>
  ) : (
    <></>
  )

const Tooltip = (props: Props) => (
  <div className="tooltip">
    <div className="tooltip__inner">
      <p className="tooltip__text">
        {I18n.t('rental_adverts.rating.created_on', { year: props.user.createdYear })}
      </p>
      {
        props.user.averageRentalRating && props.user.averageRentalRating.count > 0 ?
          <p className="tooltip__text tooltip__text--less-space">
            {I18n.t('users.advertiser.average_rating_label')}
            <div className="tooltip__score">
              <FormattedNumber
                value={props.user.averageRentalRating.rating}
                minimumFractionDigits={1}
                maximumFractionDigits={1}
              />
            </div>
          </p>
        : ''
      }
      {props.verifiedAspects.kind === 'loaded' ? (
        <VerifiedAspects aspects={props.verifiedAspects.value} />
      ) : (
        <></>
      )}

      <a href={props.overviewPath}>
        {I18n.t('users.advertiser.go_to_profile')}
      </a>
      
      <button
        className="tooltip__button"
        title={I18n.t('users.terms.close')}
        onClick={(e) => {
          e.preventDefault()
          props.onCloseTooltip()
        }}
      >
        <span className="sr-text">{I18n.t('users.terms.close')}</span>
      </button>
    </div>
  </div>
)

const TooltipLoadingComponent = (props: Props) => (
  <div className="tooltip">
    <div className="tooltip__inner">
      <button
        className="tooltip__button"
        onClick={e => {
          e.preventDefault()
          props.onCloseTooltip()
        }}
      />
      <p className="tooltip__text">
        <LoaderCircle />
      </p>
    </div>
  </div>
)

const OutTooltipLoadingComponent = OnClickOut<Props>(TooltipLoadingComponent)

const OutTooltipComponent = OnClickOut<Props>(Tooltip)

const tooltipWidget = (
  props: Props
): Widget<Action<AsyncState<VerifiedAspect[]>>> =>
  props.verifiedAspects.kind === 'loading'
    ? any<Action<AsyncState<VerifiedAspect[]>>>()([
        async<VerifiedAspect[]>()(props.verifiedAspects),
        fromJSX(() => (
          <OutTooltipLoadingComponent
            {...props}
            handleClickOutside={() => props.onCloseTooltip()}
          />
        ))
      ])
    : fromJSX(() => (
        <OutTooltipComponent
          {...props}
          handleClickOutside={() => props.onCloseTooltip()}
        />
      ))

export const AdvertiserInfo = (props: Props) : JSX.Element => {
  const onTooltipToggle = (e: React.MouseEvent) => {
    e.preventDefault()
    props.onTooltipToggle()
  }
  return (
  <div className="owner-block">
    <div className="media media--owner advertiser-information">
      <div className="media__image">
        <a href={props.overviewPath} onClick={(e) => onTooltipToggle(e)}>
          <img src={props.user.image && props.user.image.exists ? props.user.image.url : props.user_placeholder.url} />
        </a>
      </div>
      <div className="media__content">
        <h3 className="media__title">
          {
            replaceWithJsx(I18n.t("rental_adverts.description.youre_visiting", { name: "%USER%" } ),  Immutable.Map({
              USER: () => (
                <a onClick={(e) => onTooltipToggle(e)} href={props.overviewPath}>
                  {props.full_name}
                </a>
              ),
            }))
          }
        </h3>
        {
          props.contact_person ? <p>{props.contact_person.telephone1 || props.contact_person.telephone2}</p> : ''
        }
        <p>
          {props.user.advertOwnersResponseTimeSentence}
        </p>
      </div>
      {
        props.tooltip_open ?
          tooltipWidget(props).run(updater => {
            props.setVerifiedAspects(s => updater(s))
          })
        : ''
      }

    </div>
  </div>
  )
}
